// @flow
import { LARGE_VIEWPORT, MEDIUM_VIEWPORT, SMALL_VIEWPORT } from '@alphaott/app-config'
import { rgba } from 'polished'

import { colorPalette } from '../colorPalettes'
import type { ColorType } from '../colorPalettes'

export const habalitvColors: ColorType = {
  ...colorPalette,
  primary: '#642D93',
  secondary: '#985EFF',
  grayText: '#B0B0B0',
  grayLabel: '#717171',
  grayBorder: 'rgba(255, 255, 255, 0.38)',
}

export const darkTheme = {
  colors: habalitvColors,
  background: {
    primary: '#181818',
    secondary: '#262626',
    highlight: habalitvColors.dark,
    select: '#2e2e2e',
    footerTop: '#401466',
    header: '#401466',
  },
  text: {
    primary: habalitvColors.primaryGray,
    secondary: habalitvColors.secondaryGray,
    disabled: habalitvColors.grayText,
    link: habalitvColors.secondaryGray,
    hint: habalitvColors.white,
    highlight: habalitvColors.secondary,
    gray: habalitvColors.primaryGray,
    seeAll: habalitvColors.secondaryGray,
    primaryContrast: '#ffffff',
  },
  border: {
    primary: habalitvColors.primaryGray,
    gray: habalitvColors.secondaryGray,
  },
  filter: {
    primary: habalitvColors.primaryGray,
    secondary: habalitvColors.secondaryGray,
    disabled: habalitvColors.secondaryGray,
    highlight: '#111111',
  },
  tabs: {
    bg: '#181818',
    containerBg: habalitvColors.dark,
    color: habalitvColors.white,
    border: habalitvColors.primary,
    scrollbarThumb: '#bdbdbd',
    programTitle: habalitvColors.white,
  },
  programGuide: {
    programBox: {
      background: {
        main: '#2e2e2e',
        hover: habalitvColors.dark,
        selected: habalitvColors.dark,
        progress: rgba(habalitvColors.primary, 0.3),
        past: rgba(habalitvColors.primary, 0.3),
        pastSelected: habalitvColors.dark,
        pastHover: habalitvColors.dark,
        empty: '#555555',
        emptyProgress: rgba(habalitvColors.primary, 0.1),
      },
      text: {
        empty: habalitvColors.secondaryGray,
      },
    },
    programGuidePictureOverlay: {
      horizontal:
        // eslint-disable-next-line max-len
        `linear-gradient(90deg, #181818 0%,${rgba('#181818', 0.97)} 13.03%,${rgba('#181818', 0.69)} 43.24%,${rgba(
          '#181818',
          0,
        )} 100%);`,
      vertical: `linear-gradient(0, #181818 0%,${rgba('#181818', 0.73)} 34.97%,${rgba('#181818', 0)} 100%);`,
    },
  },
  card: {
    title: habalitvColors.white,
    subTitle: habalitvColors.secondaryGray,
    bg: habalitvColors.grayText,
    number: '#DFDFDF',
    boxShadow: '#2e2e2e',
    loaderBackgroundImage: 'linear-gradient(to right, #222 0%, #111 20%, #222 40%, #222 100%)',
  },
  dimension: {
    signLogoSize: 160,
  },
  size: 'default',
  breakpoints: [`${SMALL_VIEWPORT}px`, `${MEDIUM_VIEWPORT}px`, `${LARGE_VIEWPORT}px`],
  signIn: {
    clipPath: false,
  },
}
